import Vue from "vue";
import Vuex from "vuex";
import Accounts from "./Accounts";
import Language from "./Language";
import Contactus from "./Contactus";
import Practitioner from "./Practitioner";
import Blogs from "./Blogs";
import Forum from "./Forum";
import Announcements from "./Announcments";
import Country from "./Country";
import Membership from "./Membership";
import NewsLetter from "./NewsLetter";
import Downloads from "./Downloads";
import Courses from "./Courses";
import Location from "./Location";
import Testimonial from "./Testimonial";
import Store from "./Store";
import Coupon from "./Coupon";
import Videos from "./Videos";
import DigitalManual from "./DigitalManual";
import Coordinator from "./Coordinator";
import Users from "./Users";
import StudyGroupAndEvents from "./StudyGroupAndEvents";
import Notification from "./Notification";
import Currency from "./Currency";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    Accounts,
    Language,
    Contactus,
    Practitioner,
    Blogs,
    Forum,
    Announcements,
    Country,
    Membership,
    NewsLetter,
    Downloads,
    Courses,
    Location,
    Testimonial,
    Store,
    Coupon,
    Videos,
    DigitalManual,
    Coordinator,
    Users,
    StudyGroupAndEvents,
    Notification,
    Currency
  },
});
